"use client"

import { newSubscriptionFlowService } from "@/store/machine"
import { useActor } from "@xstate/react"
import { usePathname, useSearchParams } from "next/navigation"
import { usePostHog } from "posthog-js/react"
import { useEffect } from "react"

export default function PostHogPageView(): null {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const posthog = usePostHog()
  const [state] = useActor(newSubscriptionFlowService)
  const abTest = state.context.quote?.meta?.ab_test

  // Track pageviews
  useEffect(() => {
    if (pathname && posthog) {
      let url = window.origin + pathname
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`
      }
      posthog.capture("$pageview", {
        $current_url: url,
      })
    }
  }, [pathname, searchParams, posthog])

  // DLM-1889: forward backend AB test assignments as PostHog person properties
  useEffect(() => {
    if (!posthog || !abTest) return
    const properties: Record<string, string> = {}
    for (const assignment of Object.values(abTest)) {
      if (assignment.branch && assignment.branch !== "NOT_ASSIGNED") {
        properties[`$feature/${assignment.name}`] = assignment.branch
      }
    }
    if (Object.keys(properties).length > 0) {
      posthog.setPersonProperties(properties)
    }
  }, [posthog, abTest])

  return null
}
